module.exports = __webpack_public_path__ + "static/media/IRL.26c0cb26.jpg";